import EmailInputV1 from "../../../../components/form_builder/elements/email_input/EmailInputV1.vue";
import {
  validateRequired,
  validateEmail
} from "../../../../helpers/validation";

export default {
  componentName: "fb-email-input-v1",
  component: EmailInputV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      placeholder: "Write something...",
      description: "",
      value: "",
      required: false,
      hidden: false,
      readonly: false,
      style: {},
      eFormEditable: true
    }
  },
  gridAttrs: {
    type: "template",
    width: 150,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    if (validateRequired(value) && !validateEmail(value))
      errors.push("This field must have a valid email format");
    return errors;
  }
};
